<header>
  <div class="menu">
    <nav
      class="navbar navbar-expand-lg navbar-dark"
      [ngClass]="{ scrolled: isScrolled }"
    >
      <div class="container">
        <div class="navbar-brand">
          <div class="nav-link logo" routerLink="/rwa/{{ lastPath }}" (click)="scrollToInit();">
            <img
              src="/assets/img/logos/logo-header-2.webp"
              loading="lazy"
              alt="logo unbrid"
            />
            <div class="shadowed-bg"></div>
          </div>
        </div>
        @if(showNavbar==false){
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          (click)="showNavbar = true"
        >
          <i class="fas fa-bars"></i>
        </button>
        } @if(showNavbar==true){
        <div class="canal cta-border-anim" (click)="viewAllCanals()">
          <a
            aria-label="telegram"
            (click)="onLoginClick($event)"
            href="https://rwa.unbrid.com"
          >
            <svg
              stroke="currentColor"
              fill="none"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke-linecap="round"
              stroke-linejoin="round"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4"></path>
            </svg>
          </a>
        </div>
        <div class="language-container-sm" (click)="viewAllLanguage()">
          <div class="selected-flag">
            <div class="flag">
              <span class="fi fi-{{ flagIco }}"></span>
            </div>
          </div>
        </div>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          (click)="showNavbar = false"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        }
        <div
          class="collapse navbar-collapse"
          [ngClass]="{ show: showNavbar }"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav mr-auto w-100 justify-content-center">
            <!-- <li
              class="nav-item"
              [ngClass]="{ active: activeSection == 'home' }"
            >
              <a
                class="nav-link"
                [ngClass]="{ active: activeSection == 'home' }"
                routerLink="/rwa"
                (click)="onLoginClick($event); scrollToSection('home')"
                href="https://rwa.unbrid.com/"
                >{{ "MENU.HOME" | translate
                }}<span class="sr-only">(current)</span></a
              >
            </li> -->
            @if(lastPath!=''){
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://rwa.unbrid.com/spaces/user/{{ lastPath }}"
                target="blank"
                >MY SPACE</a
              >
            </li>
            }
            <!-- <li
              class="nav-item"
              [ngClass]="{ active: activeSection == 'sectors' }"
            >
              <a
                class="nav-link"
                [ngClass]="{ active: activeSection == 'sectors' }"
                (click)="onLoginClick($event); scrollToSection('sectors')"
                href="https://rwa.unbrid.com/2030"
                >2030<span class="sr-only"></span
              ></a>
            </li> -->
            <li
              class="nav-item"
              [ngClass]="{ active: activeSection == 'prosperity' }"
            >
              <a
                class="nav-link"
                [ngClass]="{
                  active:
                    activeSection == 'prosperity' || activeSection == 'stages'
                }"
                routerLink="/rwa/{{ lastPath }}"
                (click)="onLoginClick($event); scrollToSection('prosperity')"
                href="https://rwa.unbrid.com/stages"
                >{{ "MENU.STAGES" | translate }}<span class="sr-only"></span
              ></a>
            </li>
            <li
              class="nav-item"
              [ngClass]="{ active: activeSection == 'rwa-types' }"
            >
              <a
                class="nav-link"
                [ngClass]="{ active: activeSection == 'rwa-types' }"
                (click)="onLoginClick($event); scrollToSection('rwa-types')"
                href="https://rwa.unbrid.com/collection/{{ lastPath }}"
                >{{ "MENU.NFTS" | translate }}<span class="sr-only"></span
              ></a>
            </li>
            <li
              class="nav-item"
              [ngClass]="{ active: activeSection == 'calculator' }"
            >
              <a
                class="nav-link"
                [ngClass]="{ active: activeSection == 'calculator' }"
                (click)="onLoginClick($event); scrollToSection('calculator')"
                href="https://rwa.unbrid.com/calculator/{{ lastPath }}"
                >{{ "MENU.CALCULATOR" | translate }}<span class="sr-only"></span
              ></a>
            </li>
            <li class="nav-item" [ngClass]="{ active: activeSection == 'faq' }">
              <a
                class="nav-link"
                [ngClass]="{ active: activeSection == 'faq' }"
                (click)="onLoginClick($event); scrollToSection('faq')"
                href="https://rwa.unbrid.com/faq/{{ lastPath }}"
                >FAQ<span class="sr-only"></span
              ></a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" href="https://unbrid.com/blog" target="blank"
                >BLOG<span class="sr-only"></span
              ></a>
            </li> -->
            <li class="nav-item no-sm">
              <div class="canal cta-border-anim">
                <a
                  aria-label="Canals"
                  (click)="showCanalMenu(); onLoginClick($event)"
                  href="https://rwa.unbrid.com"
                >
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4"></path>
                  </svg>
                </a>
                @if(showCanal==true){
                <div
                  class="canal-container-selector"
                  (clickOutside)="onClickedOutside($event)"
                  [delayClickOutsideInit]="true"
                >
                  <app-canal-selector></app-canal-selector>
                </div>
                }
              </div>
            </li>
            <li class="nav-item no-sm">
              <div class="language-container">
                <div class="selected-flag">
                  <div class="flag">
                    <span class="fi fi-{{ flagIco }}"></span>
                  </div>
                </div>
                <div class="container-arrow">
                  <div class="arrow">
                    <div class="arrow-icon">
                      <span
                        class="fa-sharp fa-solid fa-chevron-down"
                        (click)="showConfigMenu()"
                      ></span>
                    </div>
                  </div>
                  @if(showConfig==true){
                  <div
                    class="language-container-selector"
                    (clickOutside)="onClickedOutside($event)"
                    [delayClickOutsideInit]="true"
                  >
                    <app-language-selector></app-language-selector>
                  </div>
                  }
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</header>
<div class="content">
  <div class="content-inside">
    <main class="main">
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
<!-- <footer class="footer">
  <div class="footer-content">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-11">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer> -->
